import * as angular from "angular";
import {IController} from "angular";

export class billingAccountBankInfo implements IController {

  billingAccount: any;

  /* @ngInject */
  constructor(private $log, private $mdDialog, private $billingAccounts) {
  }

  edit(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/billing-accounts/components/billing-account-bank-info/edit-billing-account-bank-info.tmpl.html',
      controller: function ($scope) {

        $scope.loading = false;
        $scope.billingAccount = angular.copy(self.billingAccount);

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {

          form.$setSubmitted(true);

          if (form.$valid) {
            $scope.loading = true;
            self.$billingAccounts(self.billingAccount.id).$post($scope.billingAccount)
              .then((billingAccount) => {
                self.billingAccount = billingAccount;
                self.$mdDialog.hide();
              })
              .catch((error) => {
                self.$log.error('Failed to edit BillingAccount', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountBankInfo', {
    bindings: {
      billingAccount: '<'
    },
    template: require('./billing-account-bank-info.tmpl.html').default,
    controller: billingAccountBankInfo
  });
